import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';

/*
  Generated class for the PonentesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PonentesProvider {

  private api: string = "";
  public listaponentes= [];
  constructor(public http: Http, public global:GlobalProvider) {
    this.api = this.global.api;
    console.log('Hello PonentesProvider Provider');

    // this.listaponentes = json 
    // o
     this.listaponentes =  window.localStorage["ponentes"];
    


  }

  // Elimina un congreso
  public delete(nponente): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "ponentes",
      "clave": nponente,
    };

    return this.http.post(this.api+"apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public insert(congreso,ponente): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    ponente.clavecongreso = congreso.clave;

    let parametros ={
      "token":this.global.token,
      "tabla": "ponentes",
      "parametros": ponente,
      "clavecongreso":ponente.clavecongreso 
   //   "imagen": imagen
    };
   
    
    return this.http.post(this.api+"apigen/insert.php", parametros, options).map(
      (response) => {
        
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public update(congreso,ponente): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "ponentes",
      "clave": ponente.clave,
      "parametros": ponente,
      "clavecongreso":ponente.clavecongreso 
    //  "imagen": imagen
    };
   
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();
         
         return respuesta[0];
      }
    ).catch(this.handleError);
  }

  public allponentes(clavecongreso): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
       "clavecongreso": clavecongreso
    };
    
    return this.http.post(this.api+"ponentes/listaponentes.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  // Devuelve todos los poenentes de un congreso
  public all(clavecongreso): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "tabla":"ponentes",
      "campofiltro":"clavecongreso",
      "valorfiltro": clavecongreso,
      "campoorden": "descripcion"
    };
   
    return this.http.post(this.api+"apigen/list.php", parametros, options).map(
      (response) => {
        
       
        // this.listaponentes =  response.json();
        // storage = this.listaponentes;
        window.localStorage["ponentes"] = response.json();
        return response.json();
        
      }
    ).catch(this.handleError);
  }


  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/providers/ponentes/ponentes.ts